import React from 'react';
import { t } from '@lingui/core/macro';

import Breadcrumbs from '@rover/components/src/navigation/Breadcrumbs';
import { Flex } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';
import { PageLayout } from '@rover/react-lib/src/components/layouts';

type Props = {
  citySeoUrl?: string | null;
  citySeoName?: string | null;
};

const SeoBreadcrumbs = ({ citySeoUrl, citySeoName }: Props): JSX.Element => {
  const theme = useTheme();
  const breadcrumbData = [
    {
      href: '/',
      title: t({
        id: 'Home.webpage',
        message: 'Home',
        comment: 'Home in the context of a webpage element',
      }),
    },
    ...(citySeoUrl && citySeoName
      ? [
          {
            href: citySeoUrl,
            title: citySeoName,
          },
        ]
      : []),
  ];

  return (
    <PageLayout style={{ margin: '0', padding: '0' }} data-testid="seo-breadcrumbs">
      <Flex pt="4x" alignItems="start" gap="1x" alignSelf="stretch">
        <Breadcrumbs
          fontWeight="semibold"
          separator="/"
          color={theme.colors.interactive_link.secondary_base}
          breadcrumbData={breadcrumbData}
          underline
          separatorStyle={{
            color: theme.textColor.tertiary,
            fontWeight: 'normal',
          }}
        />
      </Flex>
    </PageLayout>
  );
};

export default SeoBreadcrumbs;
